module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"The log is empty","leaveComment":"Leave a comment","goBack":"Go back"}}')
  delete Component.options._Ctor
}
